import { UseFormSetError } from 'react-hook-form';

export const checkTime = (value: string, setError: UseFormSetError<any>, toastErrors: string[]) => {
  const [hours, minutes] = value.split(':');

  const errorMessage = 'Время прибытия указано неверно';

  if (Number(hours) > 23 || Number(minutes) > 59) {
    setError('time', {
      type: 'manual',
      message: errorMessage,
    });
    toastErrors.push(errorMessage);
  }
};
